import { Link } from "@tanstack/react-router"
import { buttonVariants } from "@/components/ui/button"
import { authClient } from "@/lib/auth-client"

export function NavbarAuth() {
  const {
    data: session,
    isPending,
    error: sessionError,
  } = authClient.useSession()

  if (session) {
    return (
      <div className="navbar-auth">
        <Link
          to="/app"
          reloadDocument
          className={buttonVariants({
            variant: "default",
            className: "public-nav-label",
          })}
        >
          Open app
        </Link>
      </div>
    )
  }

  return (
    <div className="navbar-auth">
      <Link
        to="/signup"
        reloadDocument
        className={buttonVariants({ variant: "accent", size: "lg" })}
        aria-busy={isPending}
      >
        Try for free
      </Link>
      {sessionError && (
        <p className="navbar-auth-error" role="status">
          Unable to check your session.
        </p>
      )}
    </div>
  )
}
